var map = {
	"./data-package.json": 181,
	"./data-resource.json": 182,
	"./fiscal-data-package.json": 183,
	"./registry.json": 184,
	"./tabular-data-package.json": 185,
	"./tabular-data-resource.json": 186
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;


//////////////////
// WEBPACK FOOTER
// ./src/profiles ^\.\/.*\.json$
// module id = 363
// module chunks = 0